// @ts-nocheck

import { match as MatchStateUtils } from '..';
import { DefaultVisibleSetsNumbers, NumberPeriodsBySport } from '../../constants/scoreboards';
import { __ } from '../../i18n/l10n';
import type { ScoreboardProps, SecondariesScoreType } from '../../states/scoreboards';
import { SportIds } from '../../types/sports';

export const computeSecondaryScores = (scores: Array<string>, categoryId: number): SecondariesScoreType => {
  const finalScores = [];

  // Cas particulier NCAA (categoryId = 800000291) pour lequel on a deux mi-temps et non pas 4 QT
  const numberOfGamePeriods =
    categoryId === 800000291 ? NumberPeriodsBySport.NCAA : NumberPeriodsBySport.BASKETBALL_AND_FOOTBALL;

  scores &&
    scores.map((score, index) => {
      return finalScores.push({
        label: scores.length > numberOfGamePeriods && index > numberOfGamePeriods - 1 ? __('!short:Overtime') : '',
        score: score.split(':'),
      });
    });

  return finalScores;
};

export default ({
  sportId,
  matchId,
  period,
  periodName,
  setScores,
  competitor1Name,
  competitor2Name,
  competitor1Flag,
  competitor2Flag,
  score,
  categoryId,
}: unknown): ScoreboardProps => {
  let scores = null;
  let gameScores = null;

  const isBackgroundHighlighted = sportId === SportIds.BASKETBALL;

  if (setScores && setScores !== '') {
    scores = setScores.split(' - ');
  }

  if (score && score !== '') {
    gameScores = score.split(':');
  }

  return {
    matchId,
    period: periodName || MatchStateUtils.statusMatchBySport(sportId, period),
    competitors: [
      {
        name: competitor1Name,
        flag: competitor1Flag,
      },
      {
        name: competitor2Name,
        flag: competitor2Flag,
      },
    ],
    scores: {
      main: {
        label: __('Total'),
        score: gameScores ? gameScores : ['', ''],
      },
      secondaries: scores && scores !== null ? computeSecondaryScores(scores, categoryId) : [],
    },
    showTimer: true,
    defaultVisibleSetsNumber: DefaultVisibleSetsNumbers.BASKETBALL_AND_FOOTBALL,
    isBackgroundHighlighted,
  };
};
